import { render, staticRenderFns } from "./CommonLeadHistory.vue?vue&type=template&id=4c9696a0&scoped=true&"
import script from "./CommonLeadHistory.vue?vue&type=script&lang=js&"
export * from "./CommonLeadHistory.vue?vue&type=script&lang=js&"
import style0 from "./CommonLeadHistory.vue?vue&type=style&index=0&id=4c9696a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9696a0",
  null
  
)

export default component.exports